import React from "react";
import { Box } from "@mui/material";
import {
  MyHrUsersImportJDolBerCard,
  MyHrUsersImportSSHRCard,
} from "my-hr/components";
import { useOcProperty } from "oc/hooks";

export const MyHrUsersImportWrapper = () => {
  const { data: importType } = useOcProperty({
    resource: "system",
    key: "importType",
  });

  if (!importType || importType === "none") return null;

  let showSSHRImportCard = importType === "sshr";
  let showJDolBerImportCard = importType === "jdolber";

  return (
    <React.Fragment>
      {showJDolBerImportCard && <MyHrUsersImportJDolBerCard />}
      {showSSHRImportCard && <MyHrUsersImportSSHRCard />}
      {(showSSHRImportCard || showJDolBerImportCard) && <Box height="16px" />}
    </React.Fragment>
  );
};

export default MyHrUsersImportWrapper;
